<div class="content-card">
  <div class="card-inner">
    <div class="font-semibold text-xl mb-4 module-name">
      Authentication Profiles List
    </div>
    <p-fluid>

      <div class="flex items-center justify-center gap-6 mb-4">
        <!-- Client Filter -->
        <div class="flex items-center gap-3">
          <label for="clientFilter" class="font-medium whitespace-nowrap">Client:</label>
          <div class="w-64">
            <p-select id="clientFilter" [options]="viewModel.clientFilterOptions()"
              [ngModel]="viewModel.selectedClientId()" (onChange)="viewModel.onClientChange($event)"
              placeholder="Select Client" [showClear]="true" optionLabel="label" optionValue="value"
              styleClass="w-full" [disabled]="viewModel.isClientFilterDisabled()">
            </p-select>
          </div>
        </div>

        <!-- Tenant Type Filter -->
        <div class="flex items-center gap-3">
          <label for="tenantTypeFilter" class="font-medium whitespace-nowrap">Tenant Type:</label>
          <div class="w-64">
            <p-select id="tenantTypeFilter" [options]="viewModel.tenantTypeFilterOptions()"
              [ngModel]="viewModel.selectedTenantTypeId()" (onChange)="viewModel.onTenantTypeChange($event)"
              placeholder="Select Tenant Type" [showClear]="true" optionLabel="label" optionValue="value" styleClass="w-full">
            </p-select>
          </div>
        </div>
      </div>

      <p-table #dt [value]="viewModel.authProfiles" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 20, 30]"
        [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} profiles"
        [globalFilterFields]="['profileName', 'username', 'profileGroup', 'tenantUrl', 'clientName', 'tenantTypeName']"
        [rowHover]="true" dataKey="id" [scrollable]="true">
        <ng-template #caption>
          <div class="flex flex-col justify-between">
            <div class="flex flex-col items-end gap-3 flex-1">
              <div class="flex gap-2" *ngIf="viewModel.isSystemUser()">
                <p-button label="Add" icon="pi pi-plus" severity="info"
                  (click)="viewModel.prepareCreateMode()"></p-button>
              </div>
              <div class="search-container">
                <p-iconfield iconPosition="left">
                  <p-inputicon>
                    <i class="pi pi-search"></i>
                  </p-inputicon>
                  <input pInputText type="text" (input)="dt.filterGlobal($any($event.target).value, 'contains')"
                    placeholder="Search..." />
                </p-iconfield>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template #header>
          <tr>
            <th style="width: 20%">Tenant Type</th>
            <th style="width: 32%">Profile Group</th>
            <th style="width: 32%">Profile Name</th>
            <th style="width: 16%">Action</th>
          </tr>
        </ng-template>
        <ng-template #body let-profile>
          <tr>
            <td>{{ profile.tenant?.tenentType }}</td>
            <td>{{ profile.profileGroup }}</td>
            <td>
              {{ profile.profileName }}
              <span *ngIf="viewModel.isProfileIncomplete(profile)"
                class="ml-2 text-orange-500 text-xs font-medium"
                pTooltip="Username or Password needs to be updated" tooltipPosition="top">
                <i class="pi pi-exclamation-triangle"></i> Incomplete
              </span>
            </td>
            <td>
              <p-button icon="pi pi-pencil" [rounded]="true" [outlined]="true" [raised]="true" severity="info"
                pTooltip="Edit" tooltipPosition="top" (onClick)="viewModel.prepareEditMode(profile)" class="mr-2">
              </p-button>
              <p-button icon="pi pi-trash" [rounded]="true" [outlined]="true" [raised]="true" severity="danger"
                pTooltip="Delete" tooltipPosition="top" (onClick)="viewModel.deleteProfile(profile)">
              </p-button>
            </td>
          </tr>
        </ng-template>

        <ng-template #emptymessage>
          <tr>
            <td colspan="7" class="noData">No authentication profiles found.</td>
          </tr>
        </ng-template>
      </p-table>
    </p-fluid>
  </div>
</div>

<!-- Create/Edit Dialog -->
<p-dialog [(visible)]="viewModel.displayDialog" [appendTo]="'body'"
  [header]="viewModel.isEditMode ? 'Edit Authentication Profile' : 'Create Authentication Profile'" [modal]="true"
  [style]="{ width: '900px' }" [dismissableMask]="false" [blockScroll]="true" [draggable]="false" [resizable]="false"
  styleClass="module-name scenario-dialog" (onHide)="viewModel.closeDialog()">

  <ng-template #content>
    <form [formGroup]="viewModel.profileForm" class="p-fluid" autocomplete="off">
      <div class="grid grid-cols-2 gap-4">
        <!-- Client -->
        <div class="field min-h-[70px]">
          <label for="clientId" class="block font-medium mb-2">Client <span class="text-red-500">*</span></label>
          <p-select id="clientId" formControlName="clientId" [options]="viewModel.clientModalOptions()" optionLabel="label"
            optionValue="value" placeholder="Select Client" [showClear]="true" class="w-full" 
            [disabled]="viewModel.isModalClientDropdownDisabled()" />
          <small class="text-red-500 block mt-1 min-h-[20px]"
            *ngIf="viewModel.profileForm.get('clientId')?.invalid && viewModel.profileForm.get('clientId')?.touched">
            Client is required.
          </small>
        </div>

        <!-- Tenant Type -->
        <div class="field min-h-[70px]">
          <label for="tenantType" class="block font-medium mb-2">Tenant Type <span class="text-red-500">*</span></label>
          <p-select id="tenantType" formControlName="tenantType" [options]="viewModel.tenantList()" optionLabel="name"
            optionValue="code" placeholder="Select Tenant Type" [showClear]="true" class="w-full" />
          <small class="text-red-500 block mt-1 min-h-[20px]"
            *ngIf="viewModel.profileForm.get('tenantType')?.invalid && viewModel.profileForm.get('tenantType')?.touched">
            Tenant Type is required.
          </small>
        </div>

        <!-- Tenant URL -->
        <div class="field min-h-[70px]">
          <label for="tenantUrl" class="block font-medium mb-2">Tenant URL <span class="text-red-500">*</span></label>
          <input id="tenantUrl" type="text" pInputText formControlName="tenantUrl" placeholder="Enter tenant URL"
            class="w-full" />
          <small class="text-red-500 block mt-1 min-h-[20px]"
            *ngIf="viewModel.profileForm.get('tenantUrl')?.invalid && viewModel.profileForm.get('tenantUrl')?.touched">
            <span *ngIf="viewModel.profileForm.get('tenantUrl')?.errors?.['required']">Tenant URL is required.</span>
            <span *ngIf="viewModel.profileForm.get('tenantUrl')?.errors?.['pattern']">Please enter a valid URL (http://
              or https://).</span>
          </small>
        </div>

        <!-- Profile Group -->
        <div class="field min-h-[70px]">
          <label for="profileGroup" class="block font-medium mb-2">Profile Group <span
              class="text-red-500">*</span></label>
          <p-autoComplete id="profileGroup" formControlName="profileGroup"
            [suggestions]="viewModel.filteredProfileGroups" (completeMethod)="viewModel.filterProfileGroups($event)"
            [dropdown]="true" [forceSelection]="false" [minLength]="0"
            placeholder="Select or type to add new profile group" [showClear]="true"
            (onClear)="viewModel.onProfileGroupClear()" [appendTo]="'body'" styleClass="w-full">
            <ng-template let-group pTemplate="item">
              <div class="flex align-items-center gap-2">
                <i
                  [class]="viewModel.isExistingGroup(group) ? 'pi pi-tag text-sm' : 'pi pi-plus text-sm text-green-600'"></i>
                <span class="flex-1">{{ group }}</span>
                <span *ngIf="!viewModel.isExistingGroup(group)" class="text-xs text-green-600">(Add Item)</span>
              </div>
            </ng-template>
          </p-autoComplete>
          <small class="text-red-500 block mt-1 min-h-[20px]"
            *ngIf="viewModel.profileForm.get('profileGroup')?.invalid && viewModel.profileForm.get('profileGroup')?.touched">
            <span *ngIf="viewModel.profileForm.get('profileGroup')?.errors?.['required']">Profile Group is
              required.</span>
            <span *ngIf="viewModel.profileForm.get('profileGroup')?.errors?.['minlength']">Profile Group must be at
              least 3 characters.</span>
          </small>
        </div>

        <!-- Profile Name -->
        <div class="field min-h-[70px]">
          <label for="profileName" class="block font-medium mb-2">Profile Name <span
              class="text-red-500">*</span></label>
          <input id="profileName" type="text" pInputText formControlName="profileName" placeholder="Enter profile name"
            class="w-full" />
          <small class="text-red-500 block mt-1 min-h-[20px]"
            *ngIf="viewModel.profileForm.get('profileName')?.invalid && viewModel.profileForm.get('profileName')?.touched">
            <span *ngIf="viewModel.profileForm.get('profileName')?.errors?.['required']">Profile Name is
              required.</span>
            <span *ngIf="viewModel.profileForm.get('profileName')?.errors?.['minlength']">Profile Name must be at least
              3 characters.</span>
          </small>
        </div>

        <!-- Username -->
        <div class="field min-h-[70px]">
          <label for="username" class="block font-medium mb-2">Username <span class="text-red-500">*</span></label>
          <input id="username" type="text" pInputText formControlName="username" placeholder="Enter username"
            class="w-full" />
          <small class="text-red-500 block mt-1 min-h-[20px]"
            *ngIf="viewModel.profileForm.get('username')?.invalid && viewModel.profileForm.get('username')?.touched">
            <span *ngIf="viewModel.profileForm.get('username')?.errors?.['required']">Username is required.</span>
            <span *ngIf="viewModel.profileForm.get('username')?.errors?.['minlength']">Username must be at least 3
              characters.</span>
          </small>
        </div>

        <!-- Password -->
        <div class="field min-h-[70px]">
          <label for="secretKey" class="block font-medium mb-2">Password <span class="text-red-500"
              *ngIf="!viewModel.isEditMode">*</span></label>
          <p-iconfield iconPosition="left">
            <input id="secretKey" [type]="viewModel.showPassword() ? 'text' : 'password'" pInputText
              formControlName="secretKey" [placeholder]="viewModel.isEditMode ? 'Enter password' : 'Enter password'"
              class="w-full" />
            <p-inputicon [class]="viewModel.showPassword() ? 'pi pi-eye-slash' : 'pi pi-eye'" class="cursor-pointer"
              (click)="viewModel.togglePasswordVisibility()"
              pTooltip="{{viewModel.showPassword() ? 'Hide' : 'Show'}} password" tooltipPosition="top">
            </p-inputicon>
          </p-iconfield>
          <small class="text-red-500 block mt-1 min-h-[20px]" *ngIf="viewModel.shouldShowPasswordError()">
            <span *ngIf="viewModel.profileForm.get('secretKey')?.errors?.['required']">Password is required.</span>
            <span *ngIf="viewModel.profileForm.get('secretKey')?.errors?.['pattern']">
              Password must contain at least 8 characters, one uppercase, one lowercase, one number and one special
              character.
            </span>
          </small>
        </div>
      </div>
    </form>
  </ng-template>

  <ng-template #footer>
    <p-button label="Cancel" icon="pi pi-times" severity="warn" (onClick)="viewModel.closeDialog()" />
    <p-button [label]="viewModel.isEditMode ? 'Update' : 'Submit'" [disabled]="viewModel.isSubmitDisabled()"
      icon="pi pi-check" severity="success" (onClick)="viewModel.saveProfile()" />
  </ng-template>
</p-dialog>

<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>